/* eslint-disable folders/match-regex, filenames/match-regex */
import React from "react";
import PropTypes from "kf-proptypes/base";

import { i18nCore as i18n } from "@base/common/libs/i18n/i18n.js";
import { I18nProvider as LinguiProvider } from "@base/common/libs/i18n/trans.js";

export function I18nProvider({ children }) {
  return <LinguiProvider i18n={i18n}>{children}</LinguiProvider>;
}

I18nProvider.propTypes = {
  children: PropTypes.element.isRequired
};
